module.exports = __webpack_public_path__ + "static/bg-hero-mobile-2147c271839795971785b12f8ec75fa2.svg";